import { createSlice } from "@reduxjs/toolkit";

const baseState = {
  token: null,
  type: null,
  userId: null,
  driverName: null,
  driverId: null,
  licenses: [],
};

const storedUserData = (() => {
  try {
    const saved = localStorage.getItem("userData");
    return saved ? JSON.parse(saved) : null;
  } catch (err) {
    console.warn("No se pudo leer userData desde localStorage:", err);
    return null;
  }
})();

const initialState = storedUserData || { ...baseState };

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserData: (state, action) => {
      const newState = { ...state, ...action.payload };
      try {
        localStorage.setItem("userData", JSON.stringify(newState));
      } catch (err) {
        console.warn("No se pudo guardar userData en localStorage:", err);
      }
      return newState;
    },
    clearUserData: () => {
      try {
        localStorage.removeItem("userData");
        localStorage.removeItem("token");
      } catch (err) {
        console.warn("No se pudo limpiar localStorage:", err);
      }
      return { ...baseState };
    },
  },
});

export const { setUserData, clearUserData } = userSlice.actions;
export default userSlice.reducer;
